import { Injectable } from '@angular/core';
import { WebApiObservableService } from 'app/web-api-observable/web-api-observable.service';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';

// Observable class extensions
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';

// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';

@Injectable()
export class FoodServiceService {

  constructor(private CommonService: WebApiObservableService) { }

  getFoods(id){

  	return this.CommonService
            .search('/foods','category', id)
            .map(this.extractData)
            .catch(this.handleError);
  }

   private extractData(res: Response) {
        let body = res;
        return body || {};
    }

    private handleError(error: any) {
        let errMsg = (error.message) ? error.message :
            error.status ? error.json() : 'Server error';
        console.error(errMsg);
        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/food-service.service.ts